import { Button } from '@appkit4/react-components/button';
import { useAuth } from 'react-oidc-context';
import './LandingPage.scss';
import { Navigate, useLocation } from 'react-router-dom';
import { AppRoutes, LoginRedirectStorageKey } from '../../Constants';
import PwCPatternHalfScreen from '../../assets/Pattern_HalfScreen.svg';
import useLocale from '../../locale/useLocale';
import useTitle from '../../helpers/useTitle';
import PwCLogoNew from '../../assets/PwCLogoNew.png';

const LandingPage = () => {
    const auth = useAuth();
    const location = useLocation();
    const { l } = useLocale();
    useTitle(l('_applicationName'));

    if (auth.isAuthenticated) {
        return <Navigate to={AppRoutes.HomePage} />;
    }

    const handleLogIn = () => {
        const returnRoute = location.state?.returnRoute;

        if (returnRoute) {
            window.sessionStorage.setItem(LoginRedirectStorageKey, returnRoute);
        }

        auth.signinRedirect();
    };

    return (
        <div>
            <div className="landing-header">
                <div>
                    <img
                        src={PwCLogoNew as string}
                        alt={l('_PwCLogo')}
                        className="logo"
                        style={{ paddingTop: 50 }}
                    />
                    <div className="landing-header-content d-flex align-items-center">
                        <div style={{ width: '40%', textAlign: 'left' }}>
                            <div>
                                <span> {l('_homePageWelcomeTo')}</span>
                            </div>
                            <span className="hero-title-text">
                                {l('_applicationName')}
                            </span>
                        </div>
                        {!auth.isAuthenticated && (
                            <Button
                                style={{ width: '40%' }}
                                onClick={handleLogIn}
                                className="login-btn ap-mt-spacing-8"
                            >
                                {l('_logInUsingPwCSSO')}
                            </Button>
                        )}
                    </div>
                </div>
                <div className="image-wrapper">
                    <img
                        className="landing-page-image"
                        src={PwCPatternHalfScreen as string}
                        alt={l('_PwCLogo')}
                    />
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
